import AssetsSpinner from '@jira/assets-app__spinner/src/SpinnerView.tsx';
import { landingPageEntryPoint } from '@jira/spa-apps__servicedesk-cmdb-landing-page/src/landingPageEntryPoint.entrypoint.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { assetsRoute } from '@jira/router-routes__assets-app-routes/src/assetsRoute.tsx';
import { getAssetsAppResources } from '@jira/router-routes__servicedesk-cmdb-entries/src/common/getCmdbResources.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import {
	LazyAssetsLayout,
	AssetsLayout,
} from '@jira/assets-app__layout/src/LayoutAssetsLayout.tsx';
import { AssetsPageConfigContainer } from '@jira/assets-app__page-config-container/src/AssetsPageConfigContainer.tsx';
// eslint-disable-next-line jira/import/file-extension-required
import { componentWithFG } from '@jira/platform__utils-feature-gates-gate-component';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { ConditionalAssetsPage } from './ui/ConditionalAssetsPage.tsx';

const assetsPageEntryPoint = createChromelessEntryPoint({
	main: landingPageEntryPoint,
});

export const assetsRouteEntry: Route = createEntry(assetsRoute, () => ({
	group: 'assets',
	LayoutOverrideComponent: AssetsLayout,
	PageConfigContainerOverride: AssetsPageConfigContainer,
	skeleton: AssetsSpinner,
	// Use component for conditional redirect when feature gate is enabled
	// eslint-disable-next-line no-restricted-syntax
	component: componentWithFG('assets_for_you', ConditionalAssetsPage, () => null),
	// Only use entryPoint when feature gate is disabled
	entryPoint: () => (fg('assets_for_you') ? undefined : assetsPageEntryPoint),
	pageId: () => 'spa-apps/servicedesk/insight/cmdb-landing-page',
	resources: getAssetsAppResources(),
	forPaint: [LazyAssetsLayout],
	perfMetricKey: 'service-management.insight-cmdb.interact-with-landing-page',
	ufoName: 'assets-app-schemas-page',
	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
